import { FetcherWithComponents } from "react-router-dom";
import { RouteErrors } from "routes/data-routes/types";


export function isFetcherReloadingAfterSubmission(fetcher: FetcherWithComponents<any> | undefined) {
  return fetcher?.state === "loading" && !!fetcher.formData;
}

export function getErrorFromFetcherData(fetcher: FetcherWithComponents<any>) {
  return (fetcher.data as RouteErrors.RouterActionError | undefined)?.error;
}
